<div #streamIframe *ngIf="channel_id" (window:resize)="onResize($event)">
    <iframe [width]="width" [height]="height" [src]="url" (load)="onLoadIframe()" allow="autoplay"></iframe>
</div>
